import Cross from 'assets/icons/cross.svg';
import Message from 'types/Message';

import classes from './FilterLink.module.scss';

type Props = {
  variant?: 'default' | 'clear';
  label: Message;
};

const FilterLink = ({ label, variant = 'default' }: Props): JSX.Element => (
  <div className={classes.wrapper}>
    {label}
    {variant === 'default' && (
      <div className={classes.iconWrapper}>
        <Cross className={classes.iconRight} />
      </div>
    )}
  </div>
);

export default FilterLink;
